import Vue from 'vue';
import VueRouter from 'vue-router';
import store from '@/store';

Vue.use(VueRouter);
const subAccountChildrenRoute = [
  {
    path: '/group/subAccount/:id/detail',
    meta: {
      title: '账号详情',
      isSubAccount: true,
    },
    component: () => import('../views/subAccount/subAccountDetail/subAccountDetail'),
  },
  {
    path: '/group/subAccount/:id/priceSetting',
    meta: {
      title: '单价设置',
      isSubAccount: true,
    },
    component: () => import('../views/subAccount/priceSetting/priceSetting'),
  },
  {
    path: '/group/subAccount/:id/liveSetting',
    meta: {
      title: '云直播设置',
      isSubAccount: true,
    },
    component: () => import('../views/subAccount/liveSetting/liveSetting'),
  },
  {
    path: '/group/subAccount/:id/vodSetting',
    meta: {
      title: '云点播设置',
      isSubAccount: true,
    },
    component: () => import('../views/subAccount/vodSetting/vodSetting'),
  },
  {
    path: '/group/subAccount/:id/materialSetting',
    meta: {
      title: '素材库设置',
      isSubAccount: true,
    },
    component: () => import('../views/subAccount/materialSetting/materialSetting'),
  },
  {
    path: '/group/subAccount/:id/businessUsage',
    meta: {
      title: '业务用量',
      isSubAccount: true,
    },
    component: () => import('../views/subAccount/businessUsage/businessUsage'),
  },
];
const accountChildrenRoute = [
  {
    path: '/group/overview',
    component: () => import('../views/account/overview/overview'),
    meta: {
      title: '平台概览',
    },
  },
  {
    path: '/group/allocatableResources',
    component: () => import('../views/account/allocatableResources/allocatableResources'),
    meta: {
      title: '分配记录'
    }
  },
  {
    path: '/group/accountAdd',
    component: () => import('../views/subAccount/accountAdd/accountAdd'),
    meta: {
      title: '新建分账号',
    },
  },
  {
    path: '/group/accountManagement',
    component: () => import('../views/subAccount/accountManagement/accountManagement'),
    meta: {
      title: '资源分配',
    },
  },
  {
    path: '/group/billStatistics',
    component: () => import('../views/account/billStatistics/billStatistics'),
    meta: {
      title: '账单统计',
    },
  },
  {
    path: '/group/businessUsage',
    component: () => import('../views/account/businessUsage/businessUsage'),
    meta: {
      title: '业务用量',
    },
  },
  {
    path: '/group/liveBroadcastStatistics',
    component: () => import('../views/account/liveBroadcastStatistics/liveBroadcastStatistics'),
    meta: {
      title: '直播场次统计',
    },
  },
  {
    path: '/group/developInfo',
    component: () => import('../views/account/developInfo/developInfo'),
    meta: {
      title: '开发设置',
    },
  },
  {
    path: '/group/accountDetail',
    component: () => import('../views/account/accountDetail/accountDetail'),
    meta: {
      title: '账号信息',
    },
  },
  {
    path: '/group/updatePassword',
    component: () => import('../views/account/updatePsw/updatePsw'),
    meta: {
      title: '修改密码',
    },
  },
  {
    path: '/group/subAccount',
    redirect: '/group/subAccount/detail',
    children: subAccountChildrenRoute,
    component: () => import('../views/subAccount/subAccount'),
  },
];
const routes = [
  {
    path: '/',
    name: 'Login',
    component: () => import('../views/login/login'),
  },
  {
    path: '/reset-password',
    name: 'Reset',
    component: () => import('../views/login/reset-password')
  },
  {
    path: '/group',
    name: 'Main',
    redirect: '/group/overview',
    children: accountChildrenRoute,
    component: () => import('../views/main/main'),
  },
];

const router = new VueRouter({
  routes,
  mode: 'history',
});

router.beforeEach((to, from, next) => {
  // 当没有token且query中携带token时, 设置为请求token
  if (!store.state.common.xAuthToken) {
    const token = to.query?.token;
    if (token) {
      store.commit('common/setXAuthToken', token);
    }
  }

  // 设置标题
  if (to.meta.title) document.title = `${to.meta.title}`;

  next();
});

export default router;
